import { ErrorSpreadsheetResult } from "../../../util/spreadsheet-data-utils";

export type BulkUpdateTicketsOfIfAttributeDesignReviewResponse = {
  result: ErrorSpreadsheetResult[];
};
